import { TrackingEvent, TrackingEventTypes } from '@cinch-nx/shared-analytics'

export type TrackingValue = 'new' | 'used'

export const ctaClickEvent = (
  trackingValue: TrackingValue,
  selectedMakeOption?: string,
  selectedModelOption?: string,
  selectedPriceFrequencyOption?: string,
): TrackingEvent => ({
  eventName: `Click on 'Search x ${trackingValue} cars' CTA button`,
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'hero',
      action: 'submit',
      value: `search ${trackingValue} cars make: ${
        selectedMakeOption ?? 'any'
      }, model: ${selectedModelOption ?? 'any'}, monthly price: ${
        selectedPriceFrequencyOption ?? 'any'
      }`,
      label: `search ${trackingValue === 'new' ? '' : 'all '}cars`,
      type: trackingValue,
    },
  },
})
